export default __webpack_public_path__ + "static/media/QSGRW_Tool_Measure.9966e110.png";